import api from 'ApiConfig';

const feeService = {
  //Fees

  getFees: async (orgId) => {
    return api.post('/admin/get-fees', { orgId });
  },

  createFees: async (feesData) => {
    return api.post('/admin/create-fees', feesData);
  },
  getFeesData: async (orgId, instituteId, year, standard) => {
    return api.post('/admin/get-student-class-fee', {
      orgId,
      instituteId,
      year,
      standard,
    });
  },

  payFees: async (formData) => {
    return api.post('/admin/pay-fees', { formData });
  },

  getStudentDetails: async (data) => {
    return api.post('/admin/get-student-detail-to-pay', data);
  },

  deleteInstallment: async (installmentId) => {
    return api.post('/admin/delete-installment', { installmentId });
  },
  updateInstallmentDate: async ({ installmentId, newDueDate, amount }) => {
    return api.post('/admin/installments/update-due-date', {
      newDueDate,
      installmentId,
      amount,
    });
  },
  addInstallment: async (data) => {
    return api.post('/admin/add-new-installmet', data);
  },
  getBatchStudentPaymentDetails: async (batchId) => {
    return api.post('/admin/get-fee-details', { batchId });
  },
};

export default feeService;
